import { z } from "zod/v4";

export const StayAiInternalSettingsDtoSchema = z.object({
  apiKey: z.string(),
});
export type StayAiInternalSettingsDto = z.infer<
  typeof StayAiInternalSettingsDtoSchema
>;
